/*
 * 1DS JS SDK Properties plugin, 3.1.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* User.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { objDefineAccessors, newId, isUndefined, getISOString, safeGetCookieMgr, getCookieValue } from "@microsoft/1ds-core-js";
var User = /** @class */function () {
  function User(coreConfig, propertiesConfig, core) {
    this.core = core;
    this._propertiesConfig = propertiesConfig;
    var cookieMgr = this._cookieMgr = safeGetCookieMgr(core, coreConfig);
    // Add MUID in user localId
    if (cookieMgr && cookieMgr.isEnabled()) {
      // Only add default local ID is hash or drop config are not enabled
      if (!this._propertiesConfig.hashIdentifiers && !this._propertiesConfig.dropIdentifiers) {
        var muidValue = getCookieValue(cookieMgr, "MUID");
        if (muidValue) {
          this.setLocalId("t:" + muidValue);
        }
      }
      if (this._propertiesConfig.enableApplicationInsightsUser) {
        // get userId or create new one if none exists
        var aiUser = getCookieValue(cookieMgr, User.userCookieName);
        if (aiUser) {
          var params = aiUser.split(User.cookieSeparator);
          if (params.length > 0) {
            this.id = params[0];
          }
        }
        if (!this.id) {
          this.id = newId(coreConfig && !isUndefined(coreConfig.idLength) ? coreConfig.idLength : 22);
          var date = new Date();
          var acqStr = getISOString(date);
          this.accountAcquisitionDate = acqStr;
          // without expiration, cookies expire at the end of the session
          // set it to 365 days from now
          // 365 * 24 * 60 * 60 * 1000 = 31536000
          var newCookie = [this.id, acqStr];
          var cookieDomain = this._propertiesConfig.cookieDomain ? this._propertiesConfig.cookieDomain : undefined;
          cookieMgr.set(User.userCookieName, newCookie.join(User.cookieSeparator), 31536000, cookieDomain);
        }
      }
    }
    // Add user language
    if (typeof navigator !== "undefined") {
      var nav = navigator;
      this.locale = nav.userLanguage || nav.language;
    }
  }
  /**
   * The userId as known by the logging library.
   */
  User.prototype.getLocalId = function () {
    if (this._customLocalId) {
      return this._customLocalId;
    }
    // Only add default local ID is hash or drop config are not enabled
    if (!this._propertiesConfig.hashIdentifiers && !this._propertiesConfig.dropIdentifiers) {
      var muidValue = getCookieValue(this._cookieMgr, "MUID");
      if (muidValue) {
        this.setLocalId("t:" + muidValue);
      }
    }
    return undefined;
  };
  User.prototype.setLocalId = function (value) {
    this._customLocalId = value;
  };
  User.cookieSeparator = "|";
  User.userCookieName = "ai_user";
  /**
   * Static constructor, attempt to create accessors
   */
  User._staticInit = function () {
    // Dynamically create get/set property accessors
    objDefineAccessors(User.prototype, "localId", User.prototype.getLocalId, User.prototype.setLocalId);
  }();
  return User;
}();
export { User };